import DeIndex from './components/Index.vue'
import DeLogin from './components/Login.vue'
import DeEstadisticas from './components/Estadisticas.vue'

const routes = [
	{
		path: '*',
		redirect: '/'
	},
	{ 
		path: '/', 
		component: DeIndex, 
		name: 'deindex'
	},
	{ 
		path: '/estadisticas', 
		component: DeEstadisticas, 
		name: 'deestadisticas'
	},
	{ 
		path: '/login',
		component: DeLogin, 
		name: 'delogin'
	}
]

export default routes


// WEBPACK FOOTER //
// ./src/routes.js